/**
 *  Builds a query string with the given params object.
 *  Query string output does not have beginning ?.
 *  Example: 'param1=val1&param2=value2&param3=value3'
 */
function buildQryString(params: { [name: string]: string }): string {
  return Object.keys(params)
    .map(p => `${p}=${encodeURIComponent(params[p])}`)
    .join('&')
}

export function openWindow(url: string, name = '', width = 600, height = 400): void {
  if (process.env.forThemer) { // TT-14629
    return
  }
  const top = (screen.height / 2) - 400
  const left = (screen.width / 2) - 600
  const windowDimensionsAndPosition = `width=${width},height=${height},top=${top},left=${left}`
  window.open(
    url,
    name,
    `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,${windowDimensionsAndPosition}`
  )
}

export default { buildQryString, openWindow }
